
export const TOGGLE_VISUALSEARCH_GRAYSCALE = 'grayscale-visualsearch/TOGGLE';

export const VISUALSEARCH_SET_IMAGE = 'VISUALSEARCH_SET_IMAGE';
export const VISUALSEARCH_SET_LUMINANCE = 'VISUALSEARCH_SET_LUMINANCE';

export interface VisualSearchResultAction {
  type: string;
  enableGrayScale?: boolean;
  imageLoaded?: boolean;
  imageSrc?: string;
  imageData?: Uint8Array;
  luminanceSearch?: boolean;
}

export function toggleVisualSearchGrayScale(enableGrayScale: boolean): VisualSearchResultAction {
  return {
    type: TOGGLE_VISUALSEARCH_GRAYSCALE,
    enableGrayScale: enableGrayScale
  };
}

export function setVisualSearchImage(imageLoaded: boolean, imageSrc: string, imageData: Uint8Array): VisualSearchResultAction {
  return {
    type: VISUALSEARCH_SET_IMAGE,
    imageLoaded: imageLoaded,
    imageSrc: imageSrc,
    imageData: imageData
  };
}

export function setVisualSearchLuminance(luminanceSearch: boolean): VisualSearchResultAction {
  return {
    type: VISUALSEARCH_SET_LUMINANCE,
    luminanceSearch: luminanceSearch
  };
}
